// extracted by mini-css-extract-plugin
export default {"infoCard":"BindOrderModal_infoCard__Wex1+","dividerStyle":"BindOrderModal_dividerStyle__HBGRX"};